/* eslint-disable */

export enum ScreenOrientation {
  UNSPECIFIED = "UNSPECIFIED",
  PORTRAIT = "PORTRAIT",
  LANDSCAPE = "LANDSCAPE",
  SQUARE = "SQUARE",
}

/** A customer's device, e.g., iPhone and Android. */
export interface Device {
  /** A unique identifier that a manufacturer (e.g., Apple or Samsung) assigns to a hardware device */
  id?: string;
  /**
   * A unique identifier that a manufacturer assigns to a device for advertising purposes.
   * Google: https://support.google.com/googleplay/android-developer/answer/6048248
   * Apple: https://developer.apple.com/documentation/adsupport/asidentifiermanager/1614151-advertisingidentifier
   */
  advertising_id?: string;
  /** example: Apple */
  manufacturer?: string;
  /** example: iPhone12 */
  model?: string;
  /** Start adding fields for Risk ML use case */
  sim_country_iso?: string;
  /** example: 310 */
  sim_mcc?: string;
  /** example: 260 */
  sim_mnc?: string;
  /** Device Screen height in pixels */
  screen_height?: number;
  /** Device Screen width in pixels */
  screen_width?: number;
  /** Pixel density (Android-only). */
  screen_density_dpi?: string;
  /** example: PORTRAIT */
  screen_orientation?: ScreenOrientation;
  /** Scale of the device's screen (iOS-only). */
  screen_scale?: number;
  type?: string;
}
